import { DataLakeFileSolutionListing } from './data-lake-file-solution-listing';

export class DataLakeFileDirectory {
    public solutionListings: DataLakeFileSolutionListing[];

    constructor() {
        this.solutionListings = [];
    }
}
